import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'empty-records-component',
    // templateUrl: './empty-records.component.html',
    templateUrl: './empty-records.v2.component.html',
    styleUrls: ['./empty-records.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmptyRecordsComponent {

  @Input() message: string;
  @Input() subMessage: string;
  @Input() labelButton: string;
  @Input() buttonClass: string = '';
  @Input() icon: string;
  @Output() emitEvent = new EventEmitter();

  emit() {
    this.emitEvent.emit();
  }

}